import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import PageWrapper from '../components/PageWrapper.vue';
import Login from '../views/Login.vue';
import Error404 from '../views/Error404.vue';
import Feedback from '../views/Feedback.vue';
import SelectClient from '../views/SelectClient.vue';
import ForgottenPassword from '../views/ForgottenPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/Dashboard',
    component: PageWrapper,
    children: [],
  },
  {
    path: '/Feedback',
    component: Feedback,
    meta: {
      title: 'Feedback',
      header: 'Feedback',
      feature: 'Feedback',
    },
  },
  {
    path: '/SelectClient',
    component: SelectClient,
    meta: { title: 'Select Client' },
  },
  {
    path: '/Login',
    component: Login,
    meta: { title: 'Login', anon: true },
  },
  {
    path: '/ForgottenPassword',
    component: ForgottenPassword,
    meta: { title: 'Forgotten Password', anon: true },
  },
  {
    path: '/ResetPassword',
    component: ResetPassword,
    meta: { title: 'Reset Password', anon: true },
  },
  {
    path: '*',
    component: Error404,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

NProgress.configure({ minimum: 0.4 });

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done(true);
});

const oldPush = router.push.bind(router);
router.push = (r) => oldPush(r).catch(() => {
  NProgress.done(true);
});

export default router;
